<template>
    <main>
        <div>
            <div v-if="showLoading" class="jleague_loader"></div>

            <div v-if="!showLoading">
                <div v-if="!isClubSelected">
                    <SelectClub
                        :favoritePlayerList="favoritePlayerList"
                        :selectedClubCodes="selectedClubCodes"
                        @club-selected="handleClubSelection"
                    />
                </div>
                <div v-if="isClubSelected">
                    <SelectFavoritePlayer
                        :selectedClubCode="selectedClubCode"
                        :favoritePlayerList="favoritePlayerList"
                        :accessToken="accessToken"
                        :selectedClubCodes="selectedClubCodes"
                        @change-view="handleViewChange"
                    />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import SelectClub from './FavoritePlayer/SelectClub.vue'
import SelectFavoritePlayer from './FavoritePlayer/SelectFavoritePlayer.vue'
import { mixinJleague } from '../mixin/utility'

export default {
    name: 'FavoritePlayer',
    mixins: [mixinJleague],
    components: {
        SelectClub,
        SelectFavoritePlayer
    },
    data() {
        return {
            selectedClubCodes: [],
            showLoading: true,
            isClubSelected: false,
            favoritePlayerList: [],
            selectedClubCode: null,
            accessToken: '',
        }
    },
    async mounted() {
    // club_cd を取得して画面切り替え
    const hash = location.hash.slice(1);
    const params = new URLSearchParams(hash.replace(/%26/g, '&'));
    const clubCdFromHash = params.get("club_cd");

    await this.fetchClubs();

    if (clubCdFromHash) {
        const club = this.getClubTeamByClubCode(clubCdFromHash);
        if (!club) {
            alert('指定されたクラブコードは存在しません。');
            return;
        }
        const alreadySelected = this.selectedClubCodes.includes(clubCdFromHash);
        if (!alreadySelected && this.selectedClubCodes.length >= 3) {
            alert('登録できるクラブは3つまでです。');
            return;
        }
        this.selectedClubCode = clubCdFromHash;
        this.isClubSelected = true;
    } 
    },
    methods: {
        async fetchClubs() {
            try {
                // ToDo
                // GET favorite_playersで、お気に入り選手が存在する場合はあらかじめクラブを選択
                const result = checkFlagment();
                if (!result.access_token) {
                    alert('不正なリクエストです。');
                    this.goToHome();
                }

                this.accessToken = result.access_token;
                const baseURL = 'https://login-api2.jleague.jp';
                const url = `${baseURL}/favorite_players`;
                const header = {
                    "Authorization": `Bearer ${this.accessToken}`,
                    "Cache-Control": "max-age=0",
                }

                const response = await fetch(url, {
                    method: 'GET',
                    headers: header
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                if (data.favorite_player_list && Array.isArray(data.favorite_player_list)) {
                    this.selectedClubCodes = data.favorite_player_list.map(item => item.club_cd);
                    this.favoritePlayerList = data.favorite_player_list;
                } else {
                    throw new Error('Unexpected response structure');
                }
            } catch (error) {
                console.error('Error fetching clubs:', error.message || error);
                alert('お気に入り選手の情報取得に失敗しました。');
                this.goToHome();
            } finally {
                this.showLoading = false;
            }
        },
        handleClubSelection(clubCode) {
            this.selectedClubCode = clubCode;
            this.isClubSelected = true;
        },
        handleViewChange(view) {
            this.isClubSelected = view === 'SelectFavoritePlayer';
            if (!this.isClubSelected) {
                this.updateSelectedClubCodes();
            }
        },
        updateSelectedClubCodes() {
            this.selectedClubCodes = this.favoritePlayerList.map(item => item.club_cd);
        },
        goToHome(){
            let originalRedirectUri;
            const hash = location.hash;
            const params = new URLSearchParams(hash.slice(1));
            originalRedirectUri = params.get("original_redirect_uri");
            window.location.href = originalRedirectUri || '/home';
        }
    }
}
</script>
